import {FC, useState} from 'react';
import {Switch} from '@mantine/core';
import Cookies from 'js-cookie';

import {EngineCookieName, EngineCookieValues} from '~/utils/constants';

import s from './styles.module.scss';

interface EngineSwitchProps {
  onChange?: (checked: boolean) => void;
}

const EngineSwitch: FC<EngineSwitchProps> = ({onChange}) => {
  const defaultCookieValue = Cookies.get(EngineCookieName);
  const [checked, setChecked] = useState(defaultCookieValue === EngineCookieValues.Ai);

  const handleChange = (isChecked: boolean) => {
    Cookies.set(EngineCookieName, isChecked ? EngineCookieValues.Ai : EngineCookieValues.Query);

    setChecked(isChecked);

    if (onChange) {
      onChange(isChecked);
    }
  };

  return (
    <div className={s['engine-switch']}>
      <div className={s['engine-switch__label']} onClick={() => handleChange(!checked)}>
        SearchNG:
      </div>
      <Switch
        checked={checked}
        onChange={(event) => handleChange(event.currentTarget.checked)}
        classNames={{
          track: s['engine-switch__switch'],
        }}
      />
    </div>
  );
};

export default EngineSwitch;
